<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.company')" >
              <j-dict-select-tag placeholder="公司" v-model="queryParam.companyCode" dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"/>
            </a-form-item>
          </a-col>
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="养户编号">-->
<!--              <j-dict-select-tag :placeholder="$t('label.pleaseSelectGrower')"  v-model="queryParam.farmerCode" dictCode="efs_md_farmer,name,code"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="养户编号">-->
<!--              <j-input :placeholder="$t('label.pleaseSelectGrower')"  v-model="queryParam.code" dictCode="efs_md_breed_batch,name,code"></j-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.grower')">
              <j-search-select-tag-option-is-value-text :placeholder="$t('label.pleaseSelectGrower')"   v-model="queryParam.farmerCode"
                                                        dict="efs_md_farmer,name,code"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="批次号">
              <j-input placeholder="请输入批次号" v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="选择日期">
              <j-date v-model="queryParam.dailyDate" placeholder="请选择日期" style="width:100%" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                 {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                 <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
               </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
        <div class="table-operator">
    <!--      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
          <a-button type="primary" icon="download" @click="handleExportXls('集团日报')">{{$t('button.export')}}</a-button>
    <!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
    <!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
    <!--      </a-upload>-->
    <!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
    <!--        <a-menu slot="overlay">-->
    <!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
    <!--        </a-menu>-->
    <!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
    <!--      </a-dropdown>-->
        </div>

    <!-- table区域-begin -->
    <div>
      <!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">-->
      <!--        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}-->
      <!--        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>-->
      <!--      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <!--        <template slot="htmlSlot" slot-scope="text">-->
        <!--          <div v-html="text"></div>-->
        <!--        </template>-->
        <!--        <template slot="imgSlot" slot-scope="text">-->
        <!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>-->
        <!--          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>-->
        <!--        </template>-->
        <!--        <template slot="fileSlot" slot-scope="text">-->
        <!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>-->
        <!--          <a-button-->
        <!--            v-else-->
        <!--            :ghost="true"-->
        <!--            type="primary"-->
        <!--            icon="download"-->
        <!--            size="small"-->
        <!--            @click="downloadFile(text)">-->
        <!--            下载-->
        <!--          </a-button>-->
        <!--        </template>-->

        <!--        <span slot="action" slot-scope="text, record">-->
        <!--          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>-->

        <!--          <a-divider type="vertical" />-->
        <!--          <a-dropdown>-->
        <!--            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>-->
        <!--            <a-menu slot="overlay">-->
        <!--              <a-menu-item>-->
        <!--                <a @click="handleDetail(record)">{{$t('button.details')}}</a>-->
        <!--              </a-menu-item>-->
        <!--              <a-menu-item>-->
        <!--                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">-->
        <!--                  <a>{{$t('button.delete')}}</a>-->
        <!--                </a-popconfirm>-->
        <!--              </a-menu-item>-->
        <!--            </a-menu>-->
        <!--          </a-dropdown>-->
        <!--        </span>-->

      </a-table>
    </div>

    <efs-statements-group-daily-modal ref="modalForm" @ok="modalFormOk"></efs-statements-group-daily-modal>
  </a-card>
</template>

<script>

import '@assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import EfsStatementsGroupDailyModal from './modules/EfsStatementsGroupDailyModal'
import JInput from '@comp/jeecg/JInput'
import JDate from '@/components/jeecg/JDate'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import JSearchSelectTagOptionIsValueText from '@/components/dict/JSearchSelectTagOptionIsValueText'

export default {
  name: 'EfsStatementsGroupDailyList',
  mixins:[JeecgListMixin, mixinDevice],
  components: {
    EfsStatementsGroupDailyModal,
    JInput,
    JDictSelectTag,
    JSearchSelectTagOptionIsValueText,
    JDate
  },
  data () {
    return {
      description: 'efs_statements_group_daily管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },
        {
          title:'服务公司',
          align:"center",
          dataIndex: 'companyCode_dictText'
        },
        {
          slotName: 'tableHeader.serviceGroup',
            scopedSlots: { title: 'tableHeader.serviceGroup'},
          align:"center",
          dataIndex: 'paDeptCode_dictText'
        },
        {
          title:'养殖户',
          align:"center",
          dataIndex: 'farmerCode_dictText'
        },
        {
          slotName: 'tableHeader.breed',
            scopedSlots: { title: 'tableHeader.breed'},
          align:"center",
          dataIndex: 'breedClassCode_dictText'
        },
        {
          slotName: 'tableHeader.cooperationModel',
            scopedSlots: { title: 'tableHeader.cooperationModel'},
          align:"center",
          dataIndex: 'cooperMode_dictText'
        },
        {
          title:'批次号',
          align:"center",
          dataIndex: 'code'
        },
        {
          title:'禽苗单价（元/只）',
          align:"center",
          dataIndex: 'chickCost'
        },
        {
          title:'养殖户缴纳押金金额（元/只）',
          align:"center",
          dataIndex: 'depositPrice'
        },
        {
          title:'进栏时间',
          align:"center",
          dataIndex: 'actHousingDate',
          customRender:function (text) {
            return !text?"":(text.length>10?text.substr(0,10):text)
          }
        },
        {
          title:'禽苗均重（g/只）',
          align:"center",
          dataIndex: 'avgWeight'
        },
        {
          title:'进苗数量（只）',
          align:"center",
          dataIndex: 'planBreedQty'
        },
        {
          title:'料肉',
          align:"center",
          dataIndex: 'stdFeedMeatAvg'
        },
        {
          title:'公/母',
          align:"center",
          dataIndex: 'sex_dictText'
        },
        {
          title:'出栏体重',
          align:"center",
          dataIndex: 'stdWeightAvg'
        },
        {
          title:'出栏日龄',
          align:"center",
          dataIndex: 'feedingStage'
        },
        {
          title:'现日龄',
          align:"center",
          dataIndex: 'nowDays'
        },
        {
          title:'剩余出栏天数',
          align:"center",
          dataIndex: 'remainingDays'
        },
        {
          title:'成活率（%）',
          align:"center",
          dataIndex: 'survivalRate'
        },
        {
          title:'剩余禽只数量（只）',
          align:"center",
          dataIndex: 'remainingQty'
        },
        {
          title:'当日死淘（只）',
          align:"center",
          dataIndex: 'deadAmoy'
        },
        {
          title:'均重(g/只)',
          align:"center",
          dataIndex: 'avgDaysWeight'
        },
        {
          title:'日采食量（g/只)',
          align:"center",
          dataIndex: 'daysFeedConsume'
        },
        {
          title:'用药成本（元/只）',
          align:"center",
          dataIndex: 'daysDrugCost'
        },
        {
          title:'疫苗成本（元/只）',
          align:"center",
          dataIndex: 'daysVaccineCost'
        },
        {
          title:'小计（元/只）',
          align:"center",
          dataIndex: 'countAllCost'
        },
        {
          title:'公司保本点',
          align:"center",
          dataIndex: 'paBreakevenPoint'
        },
        {
          title:'成禽价格',
          align:"center",
          dataIndex: 'dailyPrice'
        },
        {
          title:'养户保本点',
          align:"center",
          dataIndex: 'pbBreakevenPoint'
        },
        {
          title:'现价与合同价差',
          align:"center",
          dataIndex: 'priceDiff'
        },
        {
          title:'净利测算（万元）',
          align:"center",
          dataIndex: 'preProfit'
        },
        {
          title:'单只利润（元/只）',
          align:"center",
          dataIndex: 'singleProfit'
        }
      ],
      url: {
        list: "/groupStatements/efsStatementsGroupDaily/list",
        delete: "/groupStatements/efsStatementsGroupDaily/delete",
        deleteBatch: "/groupStatements/efsStatementsGroupDaily/deleteBatch",
        exportXlsUrl: "/groupStatements/efsStatementsGroupDaily/exportXls",
        importExcelUrl: "groupStatements/efsStatementsGroupDaily/importExcel",

      },
      dictOptions:{},
    }
  },
  created() {
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
  },
  methods: {
    initDictConfig(){
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
